import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS, ADMIN_USER_ROLE } from '../const.config';
import { checkAdminUserRole } from '../../utils/local-cache.util';

const getAdminRole = checkAdminUserRole();
// Channels module configurations
export const LISTING_COLUMNS = [
  {
    id: 'code',
    label: 'Code',
    width: '20%',
    align: 'left',
    dataKey: 'code',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'title',
    label: 'Title',
    width: '25%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'channelPoster',
    label: 'Background Image',
    width: '5%',
    align: 'center',
    dataKey: 'channelPoster',
    sortable: false,
    type: CELL_DATA_TYPES.IMAGE,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'showCollectionOnHome',
    label: 'Show Collection on Home',
    width: '20%',
    align: 'center',
    dataKey: 'showCollectionOnHome',
    sortable: true,
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '20%',
    align: 'center',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    width: '20%',
    align: 'center',
    dataKey: 'modifiedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.CONFIG.value,
    label: ACTIONS.CONFIG.label,
  },
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
    conditional: () => getAdminRole === ADMIN_USER_ROLE.ADMIN,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
    conditional: () => getAdminRole === ADMIN_USER_ROLE.ADMIN,
  },
  {
    action: ACTIONS.CATEGORY_SEQUENCE.value,
    label: ACTIONS.CATEGORY_SEQUENCE.label,
  },
  {
    action: ACTIONS.COLLECTION_SEQUENCE.value,
    label: ACTIONS.COLLECTION_SEQUENCE.label,
  },
  {
    action: ACTIONS.UPLOAD_BACKGROUND.value,
    label: ACTIONS.UPLOAD_BACKGROUND.label,
  },
];

export const VIEW_CHANNELS_COLUMNS = [
  {
    id: 'name',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'showCollectionOnHome',
    label: 'Show Collection on Home',
    dataKey: 'showCollectionOnHome',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'code',
    label: 'Code',
    dataKey: 'code',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    dataKey: 'modifiedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
